import { render } from "./PackageParameter.vue?vue&type=template&id=69461515"
import script from "./PackageParameter.vue?vue&type=script&lang=js"
export * from "./PackageParameter.vue?vue&type=script&lang=js"

import exportComponent from "E:\\www_spf_delivery_thai\\@Developing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__